import service from '@/api';
import request from '@/utils/request';

/**
 * 获取素材分组
 */
export const getMaterialCategory = (params) =>
  service.post(
    '/dapi/b-access-layer/v1/access/knowledge-config-center/v1/group/list',
    params,
  );

/**
 * 获取素材列表
 */
export const getMaterial = (params) =>
  service.post(
    '/dapi/b-access-layer/v1/access/template-center/material/pageList',
    params,
  );

/**
 * 获了图文素材
 */
export const getLinkMaterial = (params) =>
  service.post(
    '/dapi/b-access-layer/v1/access/content-management/content/list2C',
    params,
  );

// 获取基础素材列表，包含图文，视频，图片，文件
export const getBaiscMaterial = (params) =>
  service.post(
    '/dapi/b-access-layer/v1/access/content-management/baiscMaterial/list2C',
    params,
  );

// 获取下级分组列表
export const getMaterialCategoryV2 = (params) =>
  service.post(
    '/dapi/b-access-layer/v1/access/knowledge-config-center/v2/group/list2C ',
    params,
  );

/**
 * 获取素材文件
 */
export function getMaterialApi(data) {
  return request({
    url: `/dapi/b-access-layer/v1/access/content-management/baiscMaterial/list2C`,
    method: 'post',
    data,
  });
}

/**
 * 获取素材文件 - 未登录
 */
export function shareGetMaterialApi(data) {
  return request({
    url: `/dapi/b-access-layer/v1/access/content-management/baiscMaterial/share/list2C`,
    method: 'post',
    data,
  });
}

/**
 * 获取搜索的素材文件
 * @param likeName 素材名称
 */
export function getAllMaterialApi(data) {
  return request({
    url: `/dapi/b-access-layer/v1/access/content-management/baiscMaterial/allList2C`,
    method: 'post',
    data,
  });
}
/**
 * 获取素材文件夹
 */
export function currGroupListApi(data) {
  return request({
    url: `/dapi/b-access-layer/v1/access/knowledge-config-center/v1/group/currGroupList`,
    method: 'post',
    data,
  });
}
/**
 * 获取素材文件夹 - 未登录
 */
export function shareCurrGroupListApi(data) {
  return request({
    url: `/dapi/b-access-layer/v1/access/knowledge-config-center/v1/group/share/currGroupList`,
    method: 'post',
    data,
  });
}
/**
 * 获取消息订阅
 */
export function currGroupListBy5LevelApi(data) {
  return request({
    url: `/dapi/b-access-layer/v1/access/knowledge-config-center/v1/group/currGroupListBy5Level`,
    method: 'post',
    data,
  });
}
// 获取登录人的搜索记录
export function getSearchRecordApi(params) {
  return request({
    url: `/dapi/b-access-layer/v1/access/content-management/baiscMaterial/getSearchRecord`,
    method: 'get',
    params,
  });
}
/**
 * 上传临时素材（三天内有效）
 */
export function uploadMediaApi(data) {
  return request({
    url: '/dapi/qw-proxy-gateway/wxwork/v1/media/uploadByCosUrl',
    method: 'post',
    data,
  });
}
// 获取预览页面素材详情
export function getMaterialDetailsApi(data) {
  return request({
    url:
      '/dapi/b-access-layer/v1/access/content-management/baiscMaterial/getShareInfo',
    method: 'post',
    data,
  });
}
// 获取用户组织架构下分组列表树形结构
export function getGroupListApi(data) {
  return request({
    url: '/dapi/b-access-layer/v1/access/knowledge-config-center/v1/group/list',
    method: 'post',
    data,
  });
}
// 获取已订阅内容
export function getSubscribeListApi(params) {
  return request({
    url:
      '/dapi/b-access-layer/v1/access/content-management/baiscMaterial/getSubscribeList',
    method: 'get',
    params,
  });
}
// 新增修改订阅
export function subscribeApi(data) {
  return request({
    url:
      '/dapi/b-access-layer/v1/access/content-management/baiscMaterial/subscribe',
    method: 'post',
    data,
  });
}
// 新增浏览记录
export function addBrowseRecordApi(data) {
  return request({
    url:
      '/dapi/b-access-layer/v1/access/content-management/baiscMaterial/browse/addBrowseRecord',
    method: 'post',
    data,
  });
}
// 新增下载记录
export function addDownloadRecordApi(data) {
  return request({
    url:
      '/dapi/b-access-layer/v1/access/content-management/baiscMaterial/download/addDownloadRecord',
    method: 'post',
    data,
  });
}
/**
 * 新增转发记录
 * @param channel 渠道：1：转发任务 2：素材库转发
 * @param sourceId 资源id
 * @param sourceIds 资源id集合，逗号分隔
 * @param sourceName 资源名称
 * @param sourceType 资源类型 1：素材 2：话术
 */
export function addForwardRecordApi(data) {
  return request({
    url:
      '/dapi/b-access-layer/v1/access/content-management/baiscMaterial/forward/addForwardRecord',
    method: 'post',
    data,
  });
}
// 获取预览页面素材详情（通过id）
export function get2BApi(params) {
  return request({
    url:
      '/dapi/b-access-layer/v1/access/content-management/baiscMaterial/get2B',
    method: 'get',
    params,
  });
}
// cos签名
export function getCosKeyApi(data) {
  return request({
    url: `dapi/b-access-layer/v1/access/knowledge-support-service/v1/support/file/tempKey?dir=material`,
    method: 'post',
    data,
  });
}
